if (!customElements.get("predictive-search")) {
  class a extends HTMLElement {
    constructor() {
      super(), this.input = this.querySelector('input[type="search"]'), this.resultsContainer = this.querySelector(".js-results-container"), this.btnSubmit = this.querySelector(".js-btn-submit"), this.btnClearText = this.querySelector(".js-btn-clear-text"), this.errorMessageContainer = this.querySelector(".js-message-error"), this.errorMessageText = this.errorMessageContainer.querySelector("[data-text]"), this.timeout = null, this.isOpen = !1, this.drawer = this.closest(".js-drawer");
      var t = document.querySelector(".drawer__content--search"),
        s = document.querySelector(".search-drawer__suggestions");
      this.input.addEventListener("input", e => {
        clearTimeout(this.timeout), this.timeout = setTimeout(() => {
          var e = this.input.value.trim();
          e.length <= 0 ? (this.close(), window.innerWidth < 990 && (t.style.height = "auto"), s && (s.style.display = "block")) : (this.isOpen = !0, this.getSearchResults(e), window.innerWidth <= 990 && (t.style.height = "100%"), s && (s.style.display = "none"))
        }, 300)
      }), this.input.addEventListener("keydown", e => {
        "Escape" === e.key && (this.input.value ? this.close() : this.drawer && this.drawer.parentElement.parentElement.toggleDrawer())
      }), this.btnClearText.addEventListener("click", e => {
        this.close(), t.style.height = "auto", s && (s.style.display = "block")
      })
    }
    async getSearchResults(e) {
      try {
        var t = await fetch(Shopify.routes.root + `search/suggest?q=${e}&resources[type]=product,page,article,collection,query&resources[limit]=8&section_id=predictive-search`);
        if (this.isOpen) {
          if (!t.ok) throw new Error(t.status);
          var s = await t.text(),
            i = (new DOMParser).parseFromString(s, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
          this.resultsContainer.innerHTML = i, this.open(), document.querySelector("quick-cart-drawer")?.initTriggers()
        }
      } catch (e) {
        this.errorMessageText.textContent = e.message, this.errorMessageContainer.classList.remove("hidden")
      }
    }
    open() {
      this.classList.add("is-open"), this.resultsContainer.classList.remove("hidden"), this.errorMessageContainer.classList.add("hidden"), this.btnSubmit.setAttribute("tabindex", "-1"), this.btnClearText.removeAttribute("disabled")
    }
    close() {
      this.isOpen = !1, this.classList.remove("is-open"), this.resultsContainer.classList.add("hidden"), this.errorMessageContainer.classList.add("hidden"), this.input.value = "", this.input.focus(), this.btnSubmit.removeAttribute("tabindex"), this.btnClearText.setAttribute("disabled", !0)
    }
  }
  customElements.define("predictive-search", a)
}